import styles from './FJAIAudioHistory.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import bkBase64 from '../../../../assets/base64/bk.js';
import musicBkBase64 from '../../../../assets/base64/music-bk.js';
import FJAIAudioItemContainer from '../container/FJAIAudioItemContainer.jsx';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import FJTab from '../../../../common/components/FJTab/FJTab.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import FJStarIcon from '../../../../assets/svg/purple-star.svg?react';
import ImageIcon from '../../../../assets/svg/image.svg?react';
import FJBlankPanel from '../../../FJMainPreview/FJBlankPanel/FJBlankPanel.jsx';

const FJAIAudioHistory = props => {
    const { historyList = [], historyTabIndex, onHistoryTabChange } = props;

    const scrollerRef = useRef(null);

    useEffect(() => {
        scrollerRef.current.scrollTop(0);
    }, [historyList.length]);

    const headerTab = [
        {
            type: FJConstant.ALL,
            text: 'all',
            isShow: true,
        },
        {
            type: FJConstant.INSTRUMENTAL,
            text: 'music',
            isShow: true,
        },
        {
            type: FJConstant.INSTRUMENTAL,
            text: 'instrumental',
            isShow: true,
        },
        {
            type: FJConstant.SOUND_EFFECT,
            text: 'sound-effect',
            isShow: true,
        },
    ];

    return (
        <div className={styles.box}>
            <div className={styles.header}>
                <div className={styles.header_mask}>
                    <img src={bkBase64} className={styles.img_bk} alt='' />
                    <img src={musicBkBase64} className={styles.img_right} alt='' />
                </div>
                <div className={styles.content}>
                    <div>
                        <div className={styles.title}>{FJLocalStore._('FlexClip-AI-music-generator')}</div>
                        <div className={styles.sub_title}>
                            {FJLocalStore._('turn-your-ideas-into-sounds')}
                            <FJStarIcon />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.header_tab}>
                <FJTab
                    dataList={headerTab}
                    textClassName={styles.header_tab_text}
                    selectClassName={styles.header_tab_box}
                    lineClass={styles.line}
                    selectedIndex={historyTabIndex}
                    onChange={onHistoryTabChange}
                />
            </div>

            <div className={styles.content_box}>
                {!historyList.length && <FJBlankPanel icon={<ImageIcon />} text={FJLocalStore._('no-creation-yet')} />}
                <FJVerticalScroller className={styles.scroll} ref={scrollerRef}>
                    <div style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                        {historyList.map(item => {
                            return <FJAIAudioItemContainer key={item.id} item={item} />;
                        })}
                        <div style={{ width: '100%', height: '60px' }} />
                    </div>
                </FJVerticalScroller>
            </div>
        </div>
    );
};
FJAIAudioHistory.propTypes = {
    historyList: PropTypes.array,
    setIsMultipleMode: PropTypes.func,
    isMultipleMode: PropTypes.bool,
    setSliceSelectList: PropTypes.func,
    historyTabIndex: PropTypes.number,
    onHistoryTabChange: PropTypes.func,
};
export default FJAIAudioHistory;
